import BottomCardInt from "../components/BottomCardInt/BottomCardInt";
import React, {useEffect, useState} from "react";
import './BottomCardGroupInt.css'
import video from "../../web/assets/video.png";
import {cosmosTrackService} from "../../../cosmosTracking/cosmosTrackService";
import {doubt_mate_banner, sale_video_tutor, super_sets_banner} from "../../../cosmosTracking/cosmosEvents";
import baseURLGlobal from "../../../utils/util";

function BottomCardGroupInt(props){
    const [openSuperSetPopUp, setOpenSuperSetPopUp] = useState(false);
    const [openDoubtMatePopUp, setOpenDoubtMatePopUp] = useState(false);
    const [showThanksModal, setShowThanksModal] = useState(false);

    const handleCardFun = (item)=> {
        item?.id == 1 ? setOpenSuperSetPopUp(true) : setOpenDoubtMatePopUp(true);
    }
    const requestCallbackFun = (type)=>{
        if(type === "superSet") {
            cosmosTrackService(super_sets_banner)
        }else if(type === "doubtMate"){
            cosmosTrackService(doubt_mate_banner);
        }
        setOpenDoubtMatePopUp(false);
        setOpenSuperSetPopUp(false);
        callbackAPIFun(type);
        setShowThanksModal(true);
    }
    const popupClosedFun = function (){
        setOpenDoubtMatePopUp(false);
        setOpenSuperSetPopUp(false);
    }
    const hideShowThanksModal = function (){
        setShowThanksModal(false);
    }
    const baseUrl = baseURLGlobal;
    var url = new URL(window.location.href);
    var token = localStorage.getItem('campaignToken');

    const callbackAPIFun  = (type)=> {
        var myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');

        const raw = JSON.stringify({
            "statType": type === "superSet" ? 20 : 17,
            ...(type === "superSet" ? { superSetRequested: 1 } : { aiConvertCallBackRequested: 1 })
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: raw
        };

        fetch(`${baseUrl}/v2/course/campaign/update`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                console.log(result); // Handle the response
            })
            .catch((error) => {
                console.error('Error:', error); // Handle errors
            });
    }

    return(
        <>
            <div className="bottomCardGroup">
                {props?.bottomCard?.map((item, i)=>{
                    const isSuperSetDisabled = props?.campaignOrg?.superSetRequested === 1 && item?.id === 1;
                    const isAIConvertDisabled = props?.campaignOrg?.aiConvertCallBackRequested === 1 && item?.id === 2;
                    return (
                        <div
                            className={`${isSuperSetDisabled || isAIConvertDisabled ? 'bottomCardDisable' : ''}`}
                            key={i}
                            onClick={() => handleCardFun(item)}>
                            <BottomCardInt cardData={item} key={i}></BottomCardInt>
                        </div>
                    )
                })}
            </div>

            {openDoubtMatePopUp &&
                <div className="campaignPopUp">
                    <div className="campaignPopUpContent">
                        <button className="btnCampaignPopUpClose" onClick={popupClosedFun}>X</button>
                        <div className="campaignPopUpBody">
                            <div className="campaignPopUpTitle">Earn 3x Through Doubt Mate</div>
                            <video className="campaignPopUpVideo"
                                   src="https://cdn-cp-assets-public.classplus.co/CampaignManager/1a9bfae999e1e3bfe6beec98c47d02c3"
                                   controls controlsList="nofullscreen nodownload noplaybackrate" disablePictureInPicture
                                   onPlay={()=>cosmosTrackService(sale_video_tutor)}></video>
                            <div className="campaignPopUpScroll">
                                <div className="campaignPopUpHelper">
                                    We're thrilled to introduce DoubtMate, a new tool that helps your students clear up their doubts quickly. They just need to take a photo of their question, and DoubtBuddy provides a clear explanation instantly. This tool will make learning easier and more fun, and it gives you insights into what students find hard.
                                </div>
                            </div>
                            <div className="campaignPopUpFooter">
                                <button className="btnCampaignPopUpGradient"
                                        onClick={()=>requestCallbackFun("doubtMate")}>
                                    Request callback
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {openSuperSetPopUp &&
                <div className="campaignPopUp">
                    <div className="campaignPopUpContent">
                        <button className="btnCampaignPopUpClose" onClick={popupClosedFun}>X</button>
                        <div className="campaignPopUpBody">
                            <div className="campaignPopUpTitle">Earn 3x Through Super Set ⚡️️</div>
                            <video className="campaignPopUpVideo"
                                   src="https://cdn-cp-assets-public.classplus.co/CampaignManager/1a9bfae999e1e3bfe6beec98c47d02c3"
                                   controls controlsList="nofullscreen nodownload noplaybackrate" disablePictureInPicture
                                   onPlay={()=>cosmosTrackService(sale_video_tutor)}></video>
                            <div className="campaignPopUpScroll">
                                <div className="campaignPopUpHelper">
                                    Introducing "Super Set," a new feature designed to help educators earn more and improve student learning. With Super Set, you can bundle courses together at attractive prices, helping you increase sales. It also lets you combine less popular courses with top sellers to get them noticed more. Plus, offer deals on course packages to keep students interested. Customize bundles to meet students' needs at lower costs. Try Super Set and see your earnings and student engagement grow effortlessly!
                                </div>
                                <div className="campaignPopUpPoster">
                                    <div className="campaignPopUpTitle">See how Super Set feature changed their lives</div>
                                    <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-gyan-live-poster.png" alt="gyanliveposter"/>
                                </div>
                            </div>
                            <div className="campaignPopUpFooter">
                                <button className="btnCampaignPopUpGradient"
                                        onClick={()=>requestCallbackFun("superSet")}>
                                    Request callback
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {showThanksModal &&
                <div className="campaignPopUp">
                    <div className="campaignPopUpContent">
                        <div className="campaignPopUpBody campaignPopUpBodyThanks">
                            <img src="https://ali-cdn-cp-assets-public.classplus.co/web/courseWebview/content/checkOk.gif" width={140} alt="okay"/>
                            <div className="campaignPopUpTitle">Thank you for your interest!</div>
                            <p>Your account manager will be in touch with you shortly.</p>
                            <button className="btnCampaignPopUpBack" onClick={hideShowThanksModal}>Go back</button>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default BottomCardGroupInt;
